import circle from '@turf/circle';
import { Attributes } from '@leverege/ui-attributes';
export function getVehiclePointFeature(position) {
  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Point',
      coordinates: [position?.lon, position?.lat]
    }
  };
}
export function getVehicleAccuracyFeature(position, accuracy, accuracyMultiplier) {
  if (position?.lat && position?.lon && typeof accuracy === 'number') {
    const c = circle([position?.lon, position?.lat], accuracy * accuracyMultiplier, {
      units: 'meters',
      steps: 100
    });
    return c;
  }
  return null;
}
export function getAccuracy(obj, positionSource) {
  let accuracy = Attributes.get('accuracy', obj.type, obj.data);
  if (accuracy != null) {
    return accuracy;
  }
  if (positionSource === 'gps') {
    accuracy = Attributes.get('gpsAccuracy', obj.type, obj.data);
  }
  if (positionSource === 'cell-wifi') {
    accuracy = Attributes.get('cellAccuracy', obj.type, obj.data);
  }
  return accuracy;
}